'use client';

import GTMEvent from '@lib/gtm_events/GTMEvent';
import Link from "next/link";
import { useState, useEffect } from "react";
import styles from "./footer.module.scss";
import { timeNowBris } from "@lib/functions/dateTimeFunctions";

export const FooterTime = () => {
    const [time, setTime] = useState<string | null>(null);

    useEffect(() => {
        setTime(timeNowBris());
    }, []);

    return <p className={styles.time}>{time}</p>;
}

/**
 * Client component for sending GTM events in footer when things are clicked.
 * 
 * @returns privacy policy and terms and conditions links 
 */
export const FooterClientLinks = () => {
    return (
        <>
            <p>
                <Link
                    href="/documents/privacy-policy"
                    target="_blank"
                    className={styles.privacy}
                    onClick={(e) => {
                        //e.preventDefault();
                        GTMEvent(
                            'pdf_download',
                            { pdf_name: 'privacy_policy' }
                        );
                    }}
                >
                    Privacy Policy
                </Link>
            </p>
            <p>
                <Link
                    href="/documents/terms-and-conditions"
                    target="_blank"
                    className={styles.privacy}
                    onClick={(e) => {
                        //e.preventDefault();
                        GTMEvent(
                            'pdf_download',
                            { pdf_name: 'terms_and_conditions' }
                        );
                    }}
                >
                    Terms and Conditions
                </Link>
            </p>
        </>
    );
};